/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import isNil from 'lodash/isNil';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router';
import format from 'date-fns/format';
import enumsActions from 'loraactions/enums';
import deviceActions from 'loraactions/device';
import PropsPanel from 'loracoms/PropsPanel';
import Nvl from 'loracoms/Nvl';
import RichLabel from 'loracoms/RichLabel';
import FormBlock from 'loracoms/FormBlock';
import { enumsToOptions } from 'lorautils/api/selector';
import {
  normalizeDevEUI,
  normalizeDevAddr,
} from 'lorautils/IdUtils';
import { isHexString } from 'lorautils/checkers/numbers';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import MapOverlay from '../MapOverlay';
import styles from './styles.scss';

const kNonEmptyIds = [
  'name',
  'appkey',
];

const kRxWindowOptions = [
  { value: 1, label: 'RX1' },
  { value: 2, label: 'RX2' },
];

const kRX1DROffsetOptions = _.range(8).map(v => ({
  value: v,
  label: String(v),
}));

const kRXDelayOptions = _.range(16).map(v => ({
  value: v,
  label: String(v),
}));

const kRX2DROptions = _.range(16).map(v => ({
  value: v,
  label: String(v),
}));

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  device: React.PropTypes.object.isRequired,
  getLwanvers: React.PropTypes.func.isRequired,
  getNodetypes: React.PropTypes.func.isRequired,
  lwanversOpts: React.PropTypes.array.isRequired,
  nodetypesOpts: React.PropTypes.array.isRequired,
  updateDevice: React.PropTypes.func.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  update: React.PropTypes.object.isRequired,
  getDevice: React.PropTypes.func.isRequired,
  getBands: React.PropTypes.func.isRequired,
  getVendors: React.PropTypes.func.isRequired,
  bandsOpts: React.PropTypes.array.isRequired,
  vendorOptsShow: React.PropTypes.array.isRequired,
  vendorOpts: React.PropTypes.object.isRequired,
};

class DeviceProps extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      device: props.device,
      errors: new ErrorSet(),
      vendorOpts: props.vendorOpts,
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.detailview');
    this.handleCancel = this.handleCancel.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitLocation = this.handleSubmitLocation.bind(this);
  }

  componentWillMount() {
    const { getLwanvers, getNodetypes, getBands, getVendors } = this.props;
    getLwanvers();
    getNodetypes();
    getBands();
    getVendors();
  }

  componentWillReceiveProps(nextProps) {
    const {
      device,
      lwanversOpts,
      nodetypesOpts,
      bandsOpts,
      vendorOptsShow,
      vendorOpts,
      update,
    } = nextProps;
    if (device !== this.props.device) {
      this.setState({ device });
    }
    if (lwanversOpts !== this.props.lwanversOpts) {
      this.setState({ lwanversOpts });
    }
    if (nodetypesOpts !== this.props.nodetypesOpts) {
      this.setState({ nodetypesOpts });
    }
    if (bandsOpts !== this.props.bandsOpts) {
      this.setState({ bandsOpts });
    }
    if (vendorOptsShow !== this.props.vendorOptsShow) {
      this.setState({ vendorOptsShow });
    }
    if (vendorOpts !== this.props.vendorOpts) {
      this.setState({ vendorOpts });
    }
    if (update !== this.props.update) {
      if (update.status === 'success') {
        const { getDevice, deviceId } = this.props;
        getDevice(deviceId);
      }
      if (update.status === 'failure') {
        if (update.error.code === 'BADFREQUENCY' ||
            update.error.code === 'BADDATARATE') {
          const { errors } = this.state;
          this.setState({ errors: errors.add(update.error.code, 'submitLora') });
        }
      }
    }
  }

  battery() {
    const { device: { data: { battery } = {} } } = this.props;
    if (battery === undefined) {
      return this.intlMsg.msg('value.batterystatuserr');
    } else if (battery === 0) {
      return this.intlMsg.msg('value.power');
    } else if (battery === 255) {
      return this.intlMsg.msg('value.unknown');
    }

    const percent = (battery / 2.54).toFixed(1);
    let icon;
    if (percent >= 99) {
      icon = <span className="halflings halflings-battery-full text-success" />;
    } else if (percent >= 75) {
      icon = <span className="halflings halflings-battery-75" />;
    } else if (percent >= 50) {
      icon = <span className="halflings halflings-battery-50" />;
    } else if (percent >= 25) {
      icon = <span className="halflings halflings-battery-25 text-warning" />;
    } else {
      icon = <span className="halflings halflings-battery-10 text-danger" />;
    }
    return <span>{`${percent}%`}{' '}{icon}</span>;
  }

  lastact() {
    const {
      device: {
        data: {
          lastact,
          lastDataUp,
          lastStatusAns,
          lastStatusReq,
        } = {},
      },
    } = this.props;
    if (lastact > 0 ||
        lastDataUp > 0 ||
        lastStatusAns > 0 ||
        lastStatusReq > 0) {
      return this.intlMsg.msg('result.active');
    }
    return this.intlMsg.msg('result.unactive');
  }

  checkNotEmpty(val, id, errors = this.state.errors) {
    if (isNil(val) || isEmpty(val)) {
      return errors.add(
        'FE_EMPTY',
        id,
        { message: this.intlMsg.errorMsg('FE_EMPTY', 'lora') },
      );
    }
    return errors.remove(id);
  }

  checkVendorver(val, errors = this.state.errors) {
    const regVen = new RegExp('^([1-9]|[1-9][0-9]|1\\d\\d|2[0-4]\\d|25[0-5])$');
    if (val !== '') {
      if (!regVen.test(val)) {
        return errors.add(
          'FE_iptNumRange',
          'vendorver',
          { message: this.intlMsg.errorMsg('FE_iptNumRange') },
        );
      }
    }
    return errors.remove('vendorver');
  }

  checkAppKey(val, errors = this.state.errors) {
    if (!isHexString(val, { len: 32 })) {
      return errors.add(
        'FE_INVALIDAPPKEY',
        'appkey',
        { message: this.intlMsg.errorMsg('FE_INVALIDAPPKEY') },
      );
    }
    return errors.remove('appkey');
  }

  checkRX2Freq(val, errors = this.state.errors) {
    if (!/^[0-9]+(\.[0-9]+)?$/.test(val)) {
      return errors.add(
        'FE_INVALIDNUM',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_INVALIDNUM') },
      );
    }
    if (!/^[0-9]+(\.[0-9]{0,4})?$/.test(val)) {
      return errors.add(
        'FE_PREC4',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_PREC4') },
      );
    }
    if (Number(val) < 100 || Number(val) > 16700) {
      return errors.add(
        'FE_OUTOFRANGE',
        'rx2freq',
        { message: this.intlMsg.errorMsg('FE_OUTOFRANGE') },
      );
    }
    return errors.remove('rx2freq');
  }

  handleChange(data, id) {
    const val = data[id];
    let { errors } = this.state;

    if (kNonEmptyIds.includes(id)) {
      errors = this.checkNotEmpty(val, id);
    }
    if (id === 'appkey') {
      errors = this.checkAppKey(data.appkey);
    }
    if (id === 'rx2freq') {
      errors = this.checkRX2Freq(val, errors);
    }
    if (id === 'vendorver') {
      errors = this.checkVendorver(val, errors);
    }
    this.setState({ errors });
  }

  handleCancel(ids) {
    let { errors } = this.state;
    ids.forEach((id) => {
      errors = errors.remove(id);
    });
    this.setState({ errors, editAuth: null });
  }

  handleSubmit(data, dirtyIds) {
    if (isEmpty(dirtyIds)) {
      return true;
    }

    let { errors } = this.state;
    errors = errors.remove('submitLora');
    this.setState({ errors });

    if (!errors.isEmpty()) {
      return false;
    }

    const udata = _.fromPairs(_.filter(
      _.toPairs(data),
      p => dirtyIds.includes(p[0]),
    ));

    if (udata.rxwindow) {
      udata.rxwindow = Number(udata.rxwindow);
    }
    if (udata.appkey) {
      udata.appkey = udata.appkey.split(/[:-]/).join('');
    }
    if (udata.rx2freq) {
      udata.rx2freq = Number(udata.rx2freq) * 10000;
    }
    if (udata.band === '') {
      udata.band = null;
    }
    if (udata.vendor) {
      const { vendorOpts } = this.state;
      const currentVen = _.filter(vendorOpts.data.list, ven => (
        ven.name === udata.vendor
      ));
      if (currentVen.length !== 0) {
        udata.vendor = Number(currentVen[0].id);
      }
    }
    if (udata.vendorver !== '') {
      udata.vendorver = Number(udata.vendorver);
    } else {
      udata.vendorver = 0;
    }

    const { updateDevice, deviceId } = this.props;
    updateDevice(deviceId, udata);
    return true;
  }

  handleSubmitLocation(point) {
    const { updateDevice, deviceId } = this.props;
    updateDevice(deviceId, {
      lng: String(point.lng),
      lat: String(point.lat),
    });
  }

  render() {
    const {
      device,
      lwanversOpts,
      nodetypesOpts,
      bandsOpts,
      vendorOptsShow,
      vendorOpts,
      errors,
      showMap = false,
    } = this.state;

    const {
      data: {
        name,
        deveui,
        devaddr,
        devid,
        type,
        lastDataUp,
        city,
        area,
        address,
        lwanver,
        rxwindow,
        appkey,
        appskey,
        nwkskey,
        lat,
        lng,
        rx1droffset,
        rxdelay,
        rx2freq,
        rx2dr,
        band,
      } = {},
      status,
    } = device;

    let {
      data: {
        vendor,
        vendorver,
      } = {},
    } = device;

    if (vendor === 0) {
      vendor = '未定义';
    } else if (vendorOpts.status === 'success') {
      const currentVen = _.filter(vendorOpts.data.list, ven => (
        Number(ven.id) === vendor
      ));
      if (currentVen.length !== 0) {
        vendor = currentVen[0].name;
      } else {
        vendor = '未定义';
      }
    }

    if (vendorver !== 0) {
      vendorver = _.join(_.concat('版本', vendorver), '');
    } else {
      vendorver = '';
    }

    const deviceBasic = {
      name,
      deveui,
      devaddr,
      devid,
      type,
      band,
      vendor,
      vendorver,
    };
    const deviceStatus = {
      battery: this.battery(),
      lastact: this.lastact(),
      lastDataUp,
    };
    const deviceLocation = {
      city,
      area,
      address,
      lat,
      lng,
    };
    const deviceLora = {
      class: device.data ? device.data.class : null,
      lwanver,
      rxwindow: rxwindow === 0 ? 1 : rxwindow,
      rx1droffset,
      rxdelay,
      rx2freq: !_.isNil(rx2freq) ? Number(rx2freq / 10000).toFixed(4) : rx2freq,
      rx2dr,
    };
    const deviceKeys = {
      appkey,
      appskey,
      nwkskey,
    };

    return (
      <div className={styles.propsPanels}>
        <PropsPanel
          title={this.intlMsg.msg('deviceproperty')}
          data={deviceBasic}
          errors={errors}
          status={status}
          properties={[{
            id: 'name',
            name: this.intlMsg.msg('props.name'),
          }, {
            id: 'deveui',
            name: this.intlMsg.msg('label.deveui'),
            readOnly: true,
            copy: () => deveui,
            formatter: x => <Nvl val={x} formatter={normalizeDevEUI} nul="empty" />,
          }, {
            id: 'devaddr',
            name: this.intlMsg.msg('label.devaddr'),
            readOnly: true,
            copy: () => devaddr,
            formatter: x => <Nvl val={x} formatter={normalizeDevAddr} nul="empty" />,
          }, {
            id: 'type',
            name: this.intlMsg.msg('label.devtype'),
            control: {
              type: 'select',
              options: nodetypesOpts,
            },
          }, {
            id: 'band',
            name: this.intlMsg.msg('label.band'),
            formatter: x => <RichLabel content={x} />,
            control: {
              type: 'select',
              options: bandsOpts,
            },
          }, {
            id: 'vendor',
            name: this.intlMsg.msg('label.vendor'),
            control: {
              type: 'select',
              options: vendorOptsShow,
            },
          }, {
            id: 'vendorver',
            name: this.intlMsg.msg('label.vendorver'),
          }, {
            id: 'devid',
            name: this.intlMsg.msg('label.devid'),
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
        <PropsPanel
          title={this.intlMsg.msg('propspanel.status')}
          readOnly
          data={deviceStatus}
          status={status}
          properties={[{
            id: 'battery',
            name: this.intlMsg.msg('label.batterystatus'),
          }, {
            id: 'lastact',
            name: this.intlMsg.msg('label.lastactstatus'),
          }, {
            id: 'lastDataUp',
            name: this.intlMsg.msg('label.lastdataup'),
            formatter: (x) => {
              if (x) {
                return <span>{format(x * 1000, 'YYYY-MM-DD HH:mm:ss')}</span>;
              }
              return <Nvl />;
            },
          }]}
        />
        <PropsPanel
          title={this.intlMsg.msg('location.title')}
          data={deviceLocation}
          status={status}
          errors={errors}
          properties={[{
            id: 'city',
            name: this.intlMsg.msg('location.city'),
          }, {
            id: 'area',
            name: this.intlMsg.msg('location.area'),
          }, {
            id: 'address',
            name: this.intlMsg.msg('location.address'),
          }, {
            id: 'coordinate',
            name: this.intlMsg.msg('location.coordinate'),
            control: {
              type: 'external',
              external: (
                <Link onClick={() => this.setState({ showMap: true })}>
                  {this.intlMsg.msg('location.editcoordinate')}{' '}
                  <i className="fa fa-map-o" />
                </Link>
              ),
            },
            formatter: () => {
              const { lng: longitude = '', lat: latitude = '' } = { lng, lat };
              if (latitude !== '' && longitude !== '') {
                return (
                  <span>
                    {`(${longitude},${latitude})`}{' '}
                    <Link onClick={() => this.setState({ showMap: true })}>
                      <i className="fa fa-map-o" />
                    </Link>
                  </span>
                );
              }
              return (
                <Link onClick={() => this.setState({ showMap: true })}>
                  {this.intlMsg.msg('location.editcoordinate')}{' '}
                  <i className="fa fa-map-o" />
                </Link>
              );
            },
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
        <PropsPanel
          title={this.intlMsg.msg('panelhead.lorawan')}
          data={deviceLora}
          status={status}
          errors={errors}
          properties={[{
            id: 'class',
            name: this.intlMsg.msg('label.clazz'),
            control: {
              type: 'select',
              options: [
                {
                  value: null,
                  label: this.intlMsg.msg('class.default'),
                  style: { color: '#DADFE1' },
                },
                { value: 'A', label: 'A' },
                { value: 'C', label: 'C' },
              ],
            },
          }, {
            id: 'lwanver',
            name: this.intlMsg.msg('label.lwanver'),
            control: {
              type: 'select',
              options: lwanversOpts,
            },
          },
          {
            id: 'rxwindow',
            name: 'RxWindow',
            control: {
              type: 'select',
              options: kRxWindowOptions,
            },
            formatter: (x) => {
              const opt = kRxWindowOptions.find(o => o.value === x);
              if (opt) {
                return <RichLabel content={opt.label} />;
              }
              return <Nvl />;
            },
          },
          {
            id: 'rx1droffset',
            name: 'RX1DROffset',
            control: {
              type: 'select',
              options: kRX1DROffsetOptions,
            },
          },
          {
            id: 'rxdelay',
            name: 'RXDelay',
            control: {
              type: 'select',
              options: kRXDelayOptions,
            },
          }, {
            id: 'rx2dr',
            name: 'RX2DR',
            control: {
              type: 'select',
              options: kRX2DROptions,
            },
          }, {
            id: 'rx2freq',
            name: 'RX2 Frequency',
            unit: 'MHz',
          }]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
          onEdit={() => { this.setState({ errors: errors.remove('submitLora') }); }}
        >
          <div className={styles.errorBlock}>
            <FormBlock
              show={errors.has('submitLora')}
              message={this.intlMsg.errorMsg(errors.get('submitLora'))}
              azStyle="danger"
              closeButton
              onHide={() => { this.setState({ errors: errors.remove('submitLora') }); }}
            />
          </div>
        </PropsPanel>
        <PropsPanel
          title="LoRaWAN AES128 Keys"
          data={deviceKeys}
          status={status}
          errors={errors}
          properties={[
            {
              id: 'appkey',
              validator: this.appkeyValid,
              name: 'AppKey',
              copy: () => appkey,
              formatter: x => <Nvl val={`${x ? x.slice(0, 6) : x}...`} nul="empty" />,
            },
            {
              id: 'nwkskey',
              name: 'NwkSKey',
              readOnly: true,
              copy: () => nwkskey,
              formatter: x => <Nvl val={`${x ? x.slice(0, 6) : x}...`} nul="empty" />,
            },
            {
              id: 'appskey',
              name: 'AppSKey',
              readOnly: true,
              copy: () => appskey,
              formatter: x => <Nvl val={`${x ? x.slice(0, 6) : x}...`} nul="empty" />,
            },
          ]}
          onCancel={this.handleCancel}
          onChange={this.handleChange}
          onSubmit={this.handleSubmit}
        />
        <MapOverlay
          devices={[device.data]}
          show={showMap}
          onHide={() => this.setState({ showMap: false })}
          onSave={this.handleSubmitLocation}
        />
      </div>
    );
  }
}

DeviceProps.propTypes = propTypes;

const mapStateToProps = state => ({
  device: state.device.getDevice || {},
  update: state.device.updateDevice,
  lwanversOpts: enumsToOptions('lwanvers', state),
  nodetypesOpts: enumsToOptions('nodetypes', state),
  bandsOpts: enumsToOptions('bands', state),
  vendorOptsShow: enumsToOptions('vendors', state),
  vendorOpts: state.enums.vendors,
});

const mapDispatchToProps = ({
  getDevice: deviceActions.getDevice,
  updateDevice: deviceActions.updateDevice,
  getLwanvers: enumsActions.lwanvers,
  getNodetypes: enumsActions.nodetypes,
  getBands: enumsActions.bands,
  getVendors: enumsActions.vendors,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(DeviceProps));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DeviceProps/index.jsx